import $ from 'jquery'
import {Core} from './core'

export class Sticky {

  constructor() {
    this.$body = $('body')
    this.$header = $('header')

    this.classes = {
      headerClass: 'header',
      headerTag: 'header',
      bannerContentTopClass: 'banner-top-content'
    }

    this.stickyClasses = {
      top: 'js-sticky-top',
      middle: 'js-sticky-middle',
      bottom: 'js-sticky-bottom'
    }

    this.stickyDatas = {
      bp: 'js-sticky-bp',
      mobile: 'js-sticky-mobile',
      desktop: 'js-sticky-desktop',
      parentTop: 'js-sticky-parent-top',
      parentBottom: 'js-sticky-parent-bottom',
      middleWidthOffset: 'js-sticky-middle-width-offset',
      topOffsetDesktop: 'js-sticky-top-offset-desktop',
      topOffsetMobile: 'js-sticky-top-offset-mobile',
    }

    this.previousScroll = 0

    this.$bannerContentTop = $(`.${this.classes.bannerContentTopClass}`)

    $(window).on('load resize scroll', this.handleStickyNav.bind(this));
  }

  stickyNav(index, element) {
    if ( ! this.$header.length ) {
      return
    }

    let $element = $(element)
    let windowHeaderTop = 0
    let stickyBp = $element.data(this.stickyDatas.bp) ?? 'md'
    let stickyTopOffset = 0

    if (Core.isBpGreaterThan(stickyBp)) {
      if ($element.data(this.stickyDatas.desktop) === undefined) {
        this.resetClasses($element)
        return
      }

      if ($element.data(this.stickyDatas.topOffsetDesktop) !== undefined) {
        stickyTopOffset = $element.data(this.stickyDatas.topOffsetDesktop)
      }
    } else {
      if ($element.data(this.stickyDatas.mobile) === undefined) {
        this.resetClasses($element)
        return
      }

      if ($element.data(this.stickyDatas.topOffsetMobile) !== undefined) {
        stickyTopOffset = $element.data(this.stickyDatas.topOffsetMobile)
      }
    }

    if ($element.hasClass(this.classes.headerClass)) {
      if (Core.isBpGreaterThan(stickyBp) && this.$bannerContentTop.length > 0) {
        windowHeaderTop = this.$bannerContentTop.outerHeight(true)
      } else {
        windowHeaderTop = 0
      }
    } else if ($element.hasClass(this.classes.bannerContentTopClass)) {
      windowHeaderTop = 0
    } else {
      if (this.previousScroll > this.currentScroll || element.classList.contains('big-submenu-wrapper')) {
        // Scroll vers le haut
        windowHeaderTop = this.$header.offset().top - this.currentScroll + this.$header.outerHeight(true)
      }
    }

    windowHeaderTop += stickyTopOffset

    let scrollTopHeader = this.currentScroll + windowHeaderTop
    let $stickyParentTop = $element.parent()
    let $stickyParentBottom = $element.parent()

    if ($element.data(this.stickyDatas.parentTop) !== undefined) {
      $stickyParentTop = $($element.data(this.stickyDatas.parentTop))
    }

    if ($element.data(this.stickyDatas.parentBottom) !== undefined) {
      $stickyParentBottom = $($element.data(this.stickyDatas.parentBottom))
    }

    let stickyTop = $stickyParentTop.offset().top
    let stickyBottom = $stickyParentBottom.offset().top + $stickyParentBottom.outerHeight(true) - $element.outerHeight(true)

    // Ajustement du debut du sticky pour le banner top
    if ($element.hasClass(this.classes.bannerContentTopClass)) {
      if (this.previousScroll < this.currentScroll) {
        // Scroll vers le bas
        stickyTop = this.$bannerContentTop.outerHeight(true) + this.$header.outerHeight(true)
      } else {
        // Scroll vers le haut
        stickyTop = 0
      }
    }

    // Ajustement du debut du sticky pour le header
    if ($element.hasClass(this.classes.headerClass)) {
      if (this.previousScroll < this.currentScroll) {
        // Scroll vers le bas
        stickyTop += this.$header.outerHeight(true)

        if (Core.isBpGreaterThan(stickyBp) && this.$bannerContentTop.length > 0) {
          stickyTop += this.$bannerContentTop.outerHeight(true)
        }
      } else {
        // Scroll vers le haut
        if (Core.isBpGreaterThan(stickyBp) && this.$bannerContentTop.length > 0) {
          stickyTop = this.$header.outerHeight(true)
        }
      }
    }

    // Ajustement si admin bar
    if (Core.isAdminFront()) {
      if ($element.hasClass(this.classes.headerClass) || (Core.isBpGreaterThan(stickyBp) && $element.hasClass(this.classes.bannerContentTopClass))) {
        stickyTop += 32
        windowHeaderTop += 32
      } else if (this.previousScroll < this.currentScroll) {
        // Other scroll to bottom
        windowHeaderTop += 32
      }
    }

    if (windowHeaderTop <= 0) {
      windowHeaderTop = 0
    }

    $element.removeClass(this.stickyClasses.top)
    $element.removeClass(this.stickyClasses.middle)
    $element.removeClass(this.stickyClasses.bottom)

    $element.removeAttr('style')

    if (scrollTopHeader < stickyTop) {
      $element.addClass(this.stickyClasses.top).trigger('sticky:top')
    } else if (scrollTopHeader > stickyBottom) {
      $element.addClass(this.stickyClasses.bottom).trigger('sticky:bottom')
    } else {
      // if ($element.hasClass(this.classes.headerClass)) {
      //   // Header and its mobile nav are positioned from this var (see critical/components/header.scss)
      //   element.style.setProperty('--header-top-pos', `${windowHeaderTop}px`)
      // } else {
        $element.css('top', windowHeaderTop)
      // }
      $element.css('left', $element.offset().left)

      if ($element.data(this.stickyDatas.middleWidthOffset) !== undefined) {
        $element.css('width', $element.outerWidth() + parseInt($element.data(this.stickyDatas.middleWidthOffset)))
      } else {
        $element.css('width', $element.outerWidth())
      }

      $element.addClass(this.stickyClasses.middle).trigger('sticky:middle')
    }
  }

  handleStickyNav(e) {
    this.currentScroll = $(window).scrollTop()

    $(`[data-${this.stickyDatas.mobile}], [data-${this.stickyDatas.desktop}]`).each(this.stickyNav.bind(this))

    this.previousScroll = this.currentScroll
  }

  resetClasses($element) {
    $element.removeClass(`${this.stickyClasses.top} ${this.stickyClasses.middle} ${this.stickyClasses.bottom}`)
    $element.removeAttr('style')
  }
}
